enum SecureKeys {
	CurrentRegion = 'CurrentRegion',
	CurrentUser = 'CurrentUser',
	MyProfile = 'MyProfile',
	FaceScanResults = 'FaceScanResults',
	MyHealthScore = 'MyHealthScore',
	MediaCategories = 'MediaCategories',
	LatestArticles = 'LatestArticles',
	WearablesSummary = 'WearablesSummary',
	EnvironmentSettings = 'EnvironmentSettings',
	WearablesGoals = 'WearablesGoals',
	RedirectRoute = 'RedirectRoute',
	/** Set when home defers verifyPermissions for consent; cleared after permissions run post-consent. */
	PendingHomePermissionVerification = 'PendingHomePermissionVerification',
	DeeplinkPath = 'DeeplinkPath',	
	LocalUser = 'LocalUser',
	CurrentScanSessionId = 'CurrentScanSessionId',
	NotificationSummary = 'NotificationSummary',
	BiometricLogin = 'BiometricLogin',
	RegistrationModel = 'RegistrationModel',
	DefualtOrginization ='DefualtOrginization',
	NotificationPermissionCheck = 'NotificationPermissionCheck',	
	LastEnvironmentFetchTime = 'LastEnvironmentFetchTime',
	NextHealthScoreRefresh = 'NextHealthScoreRefresh',
	LastProfileRefresh = 'LastProfileRefresh',
	NextFaceScanRefresh = 'NextFaceScanRefresh',
	HealthScoreHistory = 'HealthScoreHistory',
	FaceScanHistory = 'FaceScanHistory',
	WearablesYesterdaySummary='WearablesYesterdaySummary',
	WearableStatisticsSummary='WearableStatisticsSummary',
	BiometricStatisticsSummary='BiometricStatisticsSummary',
	VivaLiteScanResult='VivaLiteScanResult',
	VivaLiteAccessCode='VivaLiteAccessCode',
	VivaLiteProfile='VivaLiteProfile',
	PointsHistory='PointsHistory',
	PKCECodeVerifier='PKCECodeVerifier',
	BiometricList='BiometricList',
	EmotionHistory='EmotionHistory',
	PatientModel='PatientModel',
	WearablePermissionPromptShown = 'WearablePermissionPromptShown',
	NotificationHistory = 'NotificationHistory',
	WearableWorkoutHistory = 'WearableWorkoutHistory',
	WearableWorkoutHistoryFetched = 'WearableWorkoutHistoryFetched',
	PointsBalance = 'PointsBalance',
	LastPointsHistoryRefresh = 'LastPointsHistoryRefresh',
	NotificationSummaryFetched = 'NotificationSummaryFetched',
	DeviceHelpLinkData = 'DeviceHelpLinkData',
	LastDeviceHelpLinkData = 'LastDeviceHelpLinkData',
	MiniAiChatQueryCache = 'MiniAiChatQueryCache',
	AiChatQueryCache = 'AiChatQueryCache',
	AIBotAutoEnabled = 'AIBotAutoEnabled',
	SilentNotificationPayloads = 'SilentNotificationPayloads',
	QuestionnaireCache = 'QuestionnaireCache',
	QuestionnaireList = 'QuestionnaireList',
	QuestionnaireHistory = 'QuestionnaireHistory',
	ActiveLeague = 'ActiveLeague',
	LastActiveLeagueRefresh = 'LastActiveLeagueRefresh',
	Leaderboard = 'Leaderboard',
	LastLeaderboardRefresh = 'LastLeaderboardRefresh',
	ProfileDimensions = 'ProfileDimensions',
	LastProfileDimensionsRefresh = 'LastProfileDimensionsRefresh',
	ObservationPinnedSettings = 'ObservationPinnedSettings',
	WhatsAppOptedInPrompted = 'WhatsAppOptedInPrompted',
	/** ISO timestamp when WhatsApp opt-in banner was first eligible to show (see WhatsAppService). */
	WhatsAppFirtsPrompt = 'WhatsAppFirtsPrompt',
	/** ISO timestamp until which the additional-information banner stays hidden (7-day snooze). */
	AdditionalInformationHiddenUntil = 'AdditionalInformationHiddenUntil',
	RequestedQuestionnaires = 'RequestedQuestionnaires',
	LastRequestedQuestionnairesRefresh = 'LastRequestedQuestionnairesRefresh',
	/** ISO timestamp of last successful /Profile/RecordAppVisit (once per hour max). */
	LastRecordAppVisit = 'LastRecordAppVisit',
	/** Persisted BCP-47 preferred culture (e.g. en-ZA). */
	PreferredCulture = 'PreferredCulture',
	/** Device-local preference for displaying en-GB weight values in stone and pounds. */
	UseStoneWeightDisplay = 'UseStoneWeightDisplay',
	/** Cached Patient Navigator external services list JSON. */
	PnServices = 'PnServices',
	/** Epoch ms of last successful PN services fetch (24h TTL). */
	LastPnServicesRefresh = 'LastPnServicesRefresh',
	/** Set on HWH registration success; cleared after the first app session ends. */
	HwhPostRegisterWelcome = 'HwhPostRegisterWelcome',

}

export const SecureStorageKey = {  ...SecureKeys };
export type SecureStorageKey = SecureKeys;
